module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comic-switcher row"
  }, [_c('div', {
    staticClass: "three columns"
  }, [_c('button', {
    staticClass: "button u-full-width",
    attrs: {
      "disabled": !_vm.canGoBack()
    },
    on: {
      "click": _vm.first
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('div', {
    staticClass: "three columns"
  }, [_c('button', {
    staticClass: "button u-full-width",
    attrs: {
      "disabled": !_vm.canGoBack()
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("‹")])]), _vm._v(" "), _c('div', {
    staticClass: "three columns"
  }, [_c('button', {
    staticClass: "button u-full-width",
    attrs: {
      "disabled": !_vm.canGoForward()
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("›")])]), _vm._v(" "), _c('div', {
    staticClass: "three columns"
  }, [_c('button', {
    staticClass: "button u-full-width",
    attrs: {
      "disabled": !_vm.canGoForward()
    },
    on: {
      "click": _vm.last
    }
  }, [_vm._v("»")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bb4a2ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComicNav.vue
// module id = 272
// module chunks = 1